import UndoIcon from '@mui/icons-material/Undo';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { MfaMode } from '@work4all/models/lib/Enums/MfaMode.enum';

import { useFormContextPlus } from '../../../../../../form-plus/use-form-context-plus';
import { UserFormValue } from '../../../types';
import { useResetMfaDialog } from '../hooks/use-reset-mfa-dialog';

const TRANSLATION_KEY_BY_MFA_MODE: Partial<Record<MfaMode, string>> = {
  [MfaMode.MAIL]: 'COMMON.EMAIL',
  [MfaMode.TOKEN]: 'COMMON.AUTH_APP',
};

export const ResetMfaContent = () => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContextPlus<UserFormValue>();

  const mfaMode = watch('mfaMode');
  const mfaModeTranslationKey = TRANSLATION_KEY_BY_MFA_MODE[mfaMode];

  const id = watch('id');
  const openResetMfaDialog = useResetMfaDialog({
    userCode: id,
    onSuccess: () => {
      setValue('mfaMode', MfaMode.NORMAL, { shouldDirty: false });
    },
  });

  if (mfaMode === MfaMode.NORMAL) {
    return <Typography>{t('SECURITY_TAB_PANEL.NO_ACTIVE_METHOD')}</Typography>;
  }

  return (
    <Box>
      <Typography>
        {t('SECURITY_TAB_PANEL.ACTIVE_METHOD', {
          method: t(mfaModeTranslationKey),
        })}
      </Typography>

      <Button onClick={openResetMfaDialog} startIcon={<UndoIcon />}>
        {t('COMMON.RESET')}
      </Button>
    </Box>
  );
};
